import api from "@/lib/api";

let pending = null;

// Visitor's 2-letter country, worked out by our own server (no third-party lookup that can rate-limit).
export function visitorCountry() {
  const hit = sessionStorage.getItem("rf_country");
  if (hit) return Promise.resolve(hit);
  if (!pending) {
    let tz = "";
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch { /* ignore */ }
    pending = api.get("/geo", { params: { tz } })
      .then(({ data }) => {
        const cc = /^[A-Z]{2}$/.test(data?.country || "") ? data.country : "";
        if (cc) sessionStorage.setItem("rf_country", cc);
        return cc;
      })
      .catch(() => "");
  }
  return pending;
}
